import { useEffect, useState } from "react";

const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    fetch("/backend/authentication/user-info/").then(
      async (resp) => {
        if (resp.status === 403) {
          if (!window.location.href.includes('login')) {
            window.location.href = '/login';
            return
          }
        }

        const {user_info} = await resp.json();
        setUserInfo(user_info);
      }
    );
  }, []);

  return userInfo;
};

export default useUserInfo;
